import React from 'react';

import PropTypes from 'prop-types';
import UAMModal from '../../../../components/UAMModal/UAMModal';
import { ConfirmationErrorButton, ConfirmationErrorH2, ConfirmationErrorOuterContainer } from './ConfirmationErrorPanelStyles';
import { composeDestinationQuerystring } from '../../../../../shared-with-server/destination-utils';
import { destinationInfo } from '../../../../destructured-front-end-config';

const ConfirmationErrorPanel = ({ destPath }) => (
  <UAMModal
    initialFocus="#backToSignIn"
    showCloseNav={false}
    headerContent={(
      <ConfirmationErrorH2>Link Expired</ConfirmationErrorH2>
    )}
    suppressFooter
  >
    <ConfirmationErrorOuterContainer>
      <p>
        This link is no longer active. Return to the{' '}
        Sign In page and enter your credentials to{' '}
        proceed.
      </p>
      <ConfirmationErrorButton
        id="backToSignIn"
        onClick={() => {
          window.location.href = `/uam/login?${composeDestinationQuerystring(destinationInfo, destPath)}`;
        }}
      >
        Back to Sign In
      </ConfirmationErrorButton>
    </ConfirmationErrorOuterContainer>
  </UAMModal>
);

ConfirmationErrorPanel.propTypes = {
  destPath: PropTypes.shape({
    dest: PropTypes.string,
    path: PropTypes.string,
    retURL: PropTypes.string,
  }).isRequired,
};

export default ConfirmationErrorPanel;
